"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiListItemButtonThemeOptions = void 0;
exports.MuiListItemButtonThemeOptions = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: ({ theme }) => {
            // The base CSS styling applied to the button
            const baseStyles = {
                textTransform: "none",
                minWidth: "unset",
                padding: theme.spacing(1, 1.5),
                color: theme.palette.gray[80],
                fontWeight: 500,
                ".MuiTypography-microText": {
                    lineHeight: "18px",
                    color: theme.palette.gray[50],
                },
            };
            // The :before CSS styling applied to the button
            const beforeStyles = {};
            // The :hover CSS styling applied to the button
            const hoverStyles = {
                backgroundColor: theme.palette.gray[20],
                ".MuiTypography-smallTextLabels": {
                    color: theme.palette.gray[90],
                },
            };
            // The :hover:before CSS styling applied to the button
            const hoverBeforeStyles = {};
            // The .Mui-disabled CSS styling applied to the button
            const disabledStyles = {};
            // The :active CSS styling applied to the button
            const activeStyles = {
                backgroundColor: theme.palette.blue["70"],
                ".MuiTypography-smallTextLabels": {
                    color: theme.palette.common.white,
                },
                ".MuiTypography-microText": {
                    color: theme.palette.blue[30],
                },
            };
            // The :focus CSS styling applied to the button
            const focusStyles = {};
            // The :focus-visible:after CSS styling applied to the button
            const focusVisibleAfterStyles = {};
            return {
                ...baseStyles,
                "&:before": beforeStyles,
                ":hover": hoverStyles,
                "&:hover:before": hoverBeforeStyles,
                ":active": activeStyles,
                "&.Mui-disabled": disabledStyles,
                ":focus-visible:after": focusVisibleAfterStyles,
                ":focus": focusStyles,
            };
        },
    },
};
